import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

type AiAgentHeaderProps = {
  hasStartedChat: boolean;
};

const AiAgentHeader: FC<AiAgentHeaderProps> = ({ hasStartedChat }) => {
  const { t } = useTranslate();

  return (
    <div className={`beta-badge ${hasStartedChat ? 'beta-badge-top' : ''}`}>
      <div className="badge-content">
        <span className="new-label">{t('New')}</span>
        <span className="beta-text">{t('AI_BannerMessage')}</span>
        <span className="learn-more">{t('ReadMore')} →</span>
      </div>
    </div>
  );
};

export default AiAgentHeader;
